import React, { createContext, useState } from 'react';

const AuthContextAdmin = createContext();

const AuthProviderAdmin = ({ children }) => {
  const [adminUser, setAdminUser] = useState(
    localStorage.getItem('adminUser') || ''
  );

  const [error, setError] = useState(null);

  const adminLogin = async (password) => {
    const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;

    if (password === adminPassword) {
      try {
        setAdminUser(true);
        localStorage.setItem('adminUser', true);
        setError(null);
      } catch (error) {
        setError(error.message);
      }
    } else {
      setError('Incorrect password');
    }
  };

  const logoutAdmin = () => {
    setAdminUser(null);
    localStorage.removeItem('adminUser');
    setError(null);
  };

  const clearError = () => setError(null);

  return (
    <AuthContextAdmin.Provider
      value={{
        userAdmin: adminUser,
        adminLogin,
        logoutAdmin,
        error,
        clearError,
      }}
    >
      {children}
    </AuthContextAdmin.Provider>
  );
};

export { AuthProviderAdmin, AuthContextAdmin };
